export default {
  steps: {
    cart: 'Košík',
    checkout: 'Pokladna',
    success: 'Hotovo',
    secure: 'ZABEZPEČENO',
  },
  heading: 'Váš košík',
  // Plural: 1 položka | 2–4 položky | 5+ položek
  itemCount: '{count} položka | {count} položky | {count} položek',
  empty: {
    title: 'Váš košík je prázdný.',
    hint: 'Prohlédněte si katalog a přidejte pár klíčů — váš výběr se zobrazí zde, připravený k objednání.',
    browseCatalog: 'Procházet katalog',
  },
  item: {
    seller: 'Prodejce: {name}',
    quantityFor: 'Množství pro {name}',
    decreaseQty: 'Snížit množství položky {name}',
    increaseQty: 'Zvýšit množství položky {name}',
    remove: 'Odebrat',
    removeLabel: 'Odebrat {name}',
  },
  continueShopping: 'Pokračovat v nákupu',
  summary: {
    subtotal: 'Mezisoučet',
    keys: 'Klíčů v objednávce',
    keysOfLimit: '{count} z {limit}',
    vatNote: 'Všechny ceny v EUR.',
    proceedToCheckout: 'K pokladně',
    instantDelivery: 'Klíče jsou doručeny okamžitě po potvrzení platby.',
  },
};
